<div class="modal-header" ngbAutofocus>
    <h3>Delete Employee</h3>
</div>
<div class="modal-body">
    <div role="alert" [ngClass]="{'alert-success' : alert.type == 'success', 'alert-default' : alert.type == 'default', 'alert-danger': alert.type == 'danger' }" *ngIf="alert != null">{{alert.msg}}</div>
    <p>This will delete all onboarding details for <b>{{data.FirstName}} {{data.LastName}}</b>. Continue?</p>
</div>
<div class="modal-footer">
    <button class="btn btn-danger" type="button" (click)="deleteClick()">Delete</button>
    <button class="btn btn-outline-dark" type="button" (click)="closeClick()">Close</button>
</div>